import styles from '../ConfigModal.module.css';

// redis icon
export function Redis(): React.JSX.Element {
  return (
    <svg className={styles.icon} viewBox="0 0 24 24" fill="currentColor">
      <path d="M4 19.5v-15A1.5 1.5 0 0 1 5.5 3h13A1.5 1.5 0 0 1 20 4.5v15a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 19.5z" />
      <path d="M7 7h10v2H7V7zm0 4h10v2H7v-2zm0 4h7v2H7v-2z" fill="white" />
      <path
        d="M7 7h10v2H7V7zm0 4h10v2H7v-2zm0 4h7v2H7v-2z"
        strokeWidth="0.5"
        stroke="currentColor"
      />
    </svg>
  );
}

// cookie icon
export function Cookie(): React.JSX.Element {
  return (
    <svg className={styles.icon} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <circle cx="15.5" cy="8.5" r="1.5" />
      <circle cx="12" cy="12" r="1.5" />
      <circle cx="8.5" cy="15.5" r="1.5" />
      <circle cx="15.5" cy="15.5" r="1.5" />
    </svg>
  );
}

// toolbox icon
export function Toolbox(): React.JSX.Element {
  return (
    <svg className={styles.icon} viewBox="0 0 24 24" fill="currentColor">
      <path d="M20 8h-3V6c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6h6v2H9V6zm11 14H4V10h16v10z" />
      <path d="M12 12h2v2h-2v-2zm-4 0h2v2H8v-2zm8 0h2v2h-2v-2z" />
    </svg>
  );
}

// memory icon
export function Memory(): React.JSX.Element {
  return (
    <svg className={styles.icon} viewBox="0 0 24 24" fill="currentColor">
      <path d="M8 2h8a2 2 0 012 2v16a2 2 0 01-2 2H8a2 2 0 01-2-2V4a2 2 0 012-2zm0 2v16h8V4H8zm2 2h4v2h-4V6zm0 4h4v2h-4v-2zm0 4h4v2h-4v-2z" />
      <path d="M6 6h2v2H6V6zm0 4h2v2H6v-2zm0 4h2v2H6v-2zm10-8h2v2h-2V6zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2z" />
    </svg>
  );
}

// server icon
export function Server(): React.JSX.Element {
  return (
    <svg className={styles.icon} viewBox="0 0 24 24" fill="currentColor">
      <path d="M4 1h16c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2zm0 2v4h16V3H4zm0 7h16c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2zm0 2v4h16v-4H4zm0 7h16c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2zm0 2v4h16v-4H4z" />
      <circle cx="7" cy="5" r="1" />
      <circle cx="7" cy="14" r="1" />
      <circle cx="7" cy="23" r="1" />
    </svg>
  );
}

// wordpress icon
export function WordPress(): React.JSX.Element {
  return (
    <svg className={styles.icon} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
      <path d="M12.5 8.5l1.5 4.5 1.5-4.5h1l-2 6h-1l-1.5-4.5L10.5 14.5h-1l-2-6h1l1.5 4.5L11.5 8.5z" />
      <path d="M7 8.5h1l1.5 4.5L11 8.5h1l-2 6H9L7 8.5z" />
      <path d="M13 8.5h1l1.5 4.5L17 8.5h1l-2 6h-1l-2-6z" />
    </svg>
  );
}

// cache icon
export function Cache(): React.JSX.Element {
  return (
    <svg className={styles.icon} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 4C7.582 4 4 7.582 4 12s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zm0 14c-3.314 0-6-2.686-6-6s2.686-6 6-6 6 2.686 6 6-2.686 6-6 6z" />
      <path
        d="M12 8v4l3 3"
        strokeWidth="2"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}

// tools icon
export function Tools(): React.JSX.Element {
  return (
    <svg className={styles.icon} viewBox="0 0 24 24" fill="currentColor">
      <path d="M21.71 20.29l-5.01-5.01A7.95 7.95 0 0018 11c0-4.41-3.59-8-8-8S2 6.59 2 11s3.59 8 8 8c1.61 0 3.09-.48 4.34-1.29l5.01 5.01a.996.996 0 101.41-1.41zM10 17c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z" />
    </svg>
  );
}

// APIs icon
export function APIs(): React.JSX.Element {
  return (
    <svg className={styles.icon} viewBox="0 0 24 24" fill="currentColor">
      <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z" />
      <path d="M7 8h2v8H7zm4 0h2v8h-2zm4 0h2v8h-2z" />
      <path d="M6 12h12v2H6z" />
    </svg>
  );
}
